import { Fragment } from 'react'
import { NextSeo } from 'next-seo'

import NavigationBar from '@/components/NavigationBar'
import Footer from '@/components/Footer'
import { AlternateLink } from '@/components/AlternateLink'

import Blogs from '@/features/landing/templates/Blogs'
import Contact from '@/features/landing/templates/Contact'
import AboutOurCompany from '@/features/resources/templates/AboutOurCompany'
import { useMeta } from '@/features/resources/constants/metaCompliance'

import { ResourcePageProps } from '@/features/resources/types'

import Hero from './Hero'
import ComplianceContent from './Content'

function ComplianceFormPage({ blogs }: ResourcePageProps): React.ReactElement {
  const META = useMeta()

  return (
    <Fragment>
      <AlternateLink />
      <NextSeo
        title={META.title}
        description={META.description}
        openGraph={{
          title: META.title,
          description: META.description,
          images: [
            {
              url: META.og.image.url,
              width: 1200,
              height: 630,
              alt: META.title,
            },
          ],
        }}
      />
      <NavigationBar />
      <Hero />
      <ComplianceContent />
      <AboutOurCompany />
      {blogs && <Blogs blogs={blogs} />}
      <Contact />
      <Footer />
    </Fragment>
  )
}

export default ComplianceFormPage
